import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// export const TitleTheme = {
//     LIGHT: '',
//     DARK: 'blanco',
// }

export const TitleColor = {
    DEFAULT: '',
    // RED: 'rojo',
    // GREEN: 'verde',
}
export const TitleStyle ={
    DEFAULT: '',
    LEAD: 'lead',
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
}

export const TitleTag = {
    DEFAULT: 'h1',
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
    P: 'p',
    SPAN: 'span',
}


function Title(props) {
    const {
        // theme,
        color,
        style,
        tag,
        children,
        className,
        onClick,
    } = props
    
    const classProps = classNames(
        '',
        {tag : style === TitleStyle.DEFAULT || style === TitleStyle.LEAD},
        // theme,
        color,
        style,
        className,
    )
    
    const TagName = tag 

    return (
        <TagName
            className={classProps}
            onClick={onClick}
        > 
            {children}
        </TagName>
    )
}
Title.propTypes = {
    // theme: PropTypes.string,
    color: PropTypes.string,
    style: PropTypes.string,
    tag: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
}
Title.defaultProps = {
    tag: TitleTag.DEFAULT,
    onClick: ()=>{},
}

export default Title
